/**
 * Chutty Nila wishlist — vanilla script (no ES module imports).
 * Stored in localStorage under chutty-wishlist.
 */
(function () {
  'use strict';

  var WISHLIST_EVENT = 'wishlist:update';
  var STORAGE_KEY = 'chutty-wishlist';
  var TOGGLE_SELECTOR = '[data-wishlist-toggle], wishlist-button[data-handle]';

  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function getCount() {
    return getItems().length;
  }

  function has(handle) {
    return getItems().some(function (item) {
      return item.handle === handle;
    });
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(
      new CustomEvent(WISHLIST_EVENT, {
        detail: { items: items, count: items.length },
      })
    );
  }

  function toggle(product) {
    if (!product || !product.handle) return false;

    var items = getItems();
    var index = items.findIndex(function (item) {
      return item.handle === product.handle;
    });

    if (index >= 0) {
      items.splice(index, 1);
      saveItems(items);
      return false;
    }

    items.push({
      handle: product.handle,
      id: Number(product.id),
      addedAt: Date.now(),
    });
    saveItems(items);
    return true;
  }

  function syncButton(button) {
    var handle = button.getAttribute('data-handle');
    var active = handle ? has(handle) : false;

    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.classList.toggle('wishlist-button--active', active);

    var addLabel = button.getAttribute('data-label-add') || 'Add to wishlist';
    var removeLabel = button.getAttribute('data-label-remove') || 'Remove from wishlist';
    button.setAttribute('aria-label', active ? removeLabel : addLabel);
  }

  function announce(button, added) {
    var region = button.querySelector('.wishlist-button__live-region, .visually-hidden[role="status"]');
    if (!region) return;

    region.textContent = added
      ? button.getAttribute('data-message-added') || 'Added to wishlist'
      : button.getAttribute('data-message-removed') || 'Removed from wishlist';
  }

  function toggleButton(button) {
    var handle = button.getAttribute('data-handle');
    var id = button.getAttribute('data-product-id');
    if (!handle || !id) return;

    var added = toggle({ handle: handle, id: Number(id) });
    syncButton(button);
    announce(button, added);
  }

  function syncAllButtons() {
    document.querySelectorAll(TOGGLE_SELECTOR).forEach(function (button) {
      syncButton(button);
    });
  }

  function handleClick(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest(TOGGLE_SELECTOR);
    if (!(button instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    toggleButton(button);
  }

  function handleKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!(event.target instanceof Element)) return;

    var button = event.target.closest(TOGGLE_SELECTOR);
    if (!(button instanceof HTMLElement) || event.target !== button) return;

    event.preventDefault();
    toggleButton(button);
  }

  function formatPrice(cents) {
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return 'Rs. ' + (Number(cents) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var HEART_PATH =
    'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';

  function createWishlistButtonElement(options) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className =
      options.className || 'wishlist-button wishlist-button--card chutty-product-card__wishlist';
    button.setAttribute('data-wishlist-toggle', '');
    button.setAttribute('data-handle', options.handle);
    button.setAttribute('data-product-id', String(options.id));
    button.setAttribute('data-label-add', options.labelAdd || 'Add to wishlist');
    button.setAttribute('data-label-remove', options.labelRemove || 'Remove from wishlist');
    button.setAttribute('data-message-added', options.messageAdded || 'Added to wishlist');
    button.setAttribute('data-message-removed', options.messageRemoved || 'Removed from wishlist');
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML =
      '<span class="visually-hidden wishlist-button__live-region" role="status"></span>' +
      '<svg class="wishlist-button__icon wishlist-button__icon--outline" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' +
      HEART_PATH +
      '" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<svg class="wishlist-button__icon wishlist-button__icon--filled" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' +
      HEART_PATH +
      '" fill="currentColor"/></svg>';
    syncButton(button);
    return button;
  }

  function renderHeaderCount(host, count, animate) {
    if (!(host instanceof HTMLElement)) return;

    var bubble = host.querySelector('[ref="wishlistBubble"], .wishlist-bubble');
    var bubbleCount = host.querySelector('[ref="wishlistBubbleCount"], .cart-bubble__text-count');
    if (!bubble || !bubbleCount) return;

    var hasItems = count > 0;
    bubbleCount.textContent = count > 0 && count < 100 ? String(count) : '';
    bubbleCount.classList.toggle('hidden', !hasItems);
    bubble.classList.toggle('visually-hidden', !hasItems);
    host.classList.toggle('header-actions__wishlist-icon--has-items', hasItems);

    if (animate && hasItems) {
      bubble.classList.add('cart-bubble--animating');
      window.setTimeout(function () {
        bubble.classList.remove('cart-bubble--animating');
      }, 300);
    }
  }

  function initWishlistIcon(host) {
    if (!(host instanceof HTMLElement) || host.dataset.wishlistIconReady === 'true') return;
    host.dataset.wishlistIconReady = 'true';

    function update(event) {
      var count = event && event.detail ? event.detail.count : getCount();
      renderHeaderCount(host, count, Boolean(event));
    }

    document.addEventListener(WISHLIST_EVENT, update);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) update();
    });
    update();
  }

  function isWishlistPath() {
    return /\/pages\/wishlist\/?$/i.test(window.location.pathname);
  }

  function mountWishlistPageIfNeeded() {
    if (!isWishlistPath()) return;
    if (document.querySelector('[data-wishlist-grid]')) return;

    var main = document.querySelector('#MainContent');
    if (!main) return;

    var shopUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var continueUrl = shopUrl + 'collections/all';

    var section = document.createElement('section');
    section.className = 'wishlist-page-section section section--page-width chutty-wishlist-mount';
    section.innerHTML =
      '<div class="chutty-inner">' +
      '<header class="chutty-section-heading" style="--chutty-heading-accent: var(--chutty-rose, #c9a7a1);">' +
      '<h1 class="chutty-section-heading__title h2">My Wishlist</h1>' +
      '<div class="chutty-section-heading__divider" aria-hidden="true">' +
      '<span class="chutty-section-heading__divider-line"></span>' +
      '<svg class="chutty-section-heading__divider-heart" viewBox="0 0 14 14" fill="currentColor">' +
      '<path d="M7 12.5S1 8.5 1 5a3 3 0 0 1 5-2 3 3 0 0 1 5 2c0 3.5-6 7.5-6 7.5z"/>' +
      '</svg>' +
      '<span class="chutty-section-heading__divider-line"></span>' +
      '</div>' +
      '</header>' +
      '<wishlist-page>' +
      '<p class="wishlist-page__loading" data-wishlist-loading hidden>Loading your wishlist...</p>' +
      '<div class="wishlist-page__empty" data-wishlist-empty hidden>' +
      '<svg class="wishlist-page__empty-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<h2 class="wishlist-page__empty-title">Your wishlist is empty</h2>' +
      '<p class="wishlist-page__empty-text">Save items you love by tapping the heart icon on any product.</p>' +
      '<a class="chutty-btn" href="' +
      continueUrl +
      '">Continue shopping</a>' +
      '</div>' +
      '<ul class="wishlist-page__grid" data-wishlist-grid hidden></ul>' +
      '</wishlist-page>' +
      '</div>';

    main.appendChild(section);
  }

  function humanizeHandle(handle) {
    return String(handle)
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
  }

  function productFromItem(item, fetchedProduct) {
    if (fetchedProduct) return fetchedProduct;

    return {
      handle: item.handle,
      id: item.id,
      title: humanizeHandle(item.handle),
      price: 0,
      featured_image: null,
    };
  }

  function createWishlistCard(product) {
    var li = document.createElement('li');
    li.className = 'wishlist-page__item';

    var handle = String(product.handle);
    var id = Number(product.id);
    var title = String(product.title);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'products/' + handle;
    var image = product.featured_image;
    var price = Number(product.price) > 0 ? formatPrice(Number(product.price)) : '';

    var imageHtml = image && image.src
      ? '<img class="chutty-product-card__image" src="' +
        escapeHtml(image.src) +
        '" alt="' +
        escapeHtml(title) +
        '" loading="lazy" width="600" height="750">'
      : '<span class="chutty-product-card__placeholder"></span>';

    li.innerHTML =
      '<div class="chutty-product-card">' +
      '<div class="chutty-product-card__media chutty-product-card__media--portrait">' +
      '<a class="chutty-product-card__media-link" href="' +
      url +
      '" aria-label="' +
      escapeHtml(title) +
      '">' +
      imageHtml +
      '</a>' +
      '<div class="chutty-product-card__actions" data-wishlist-actions></div>' +
      '</div>' +
      '<div class="chutty-product-card__body">' +
      '<a class="chutty-product-card__link" href="' +
      url +
      '">' +
      '<h3 class="chutty-product-card__title">' +
      escapeHtml(title) +
      '</h3>' +
      (price
        ? '<div class="chutty-product-card__pricing"><span class="chutty-product-card__price">' +
          price +
          '</span></div>'
        : '') +
      '</a>' +
      '</div>' +
      '</div>';

    var actions = li.querySelector('[data-wishlist-actions]');
    if (actions) {
      actions.appendChild(
        createWishlistButtonElement({
          className:
            'wishlist-button chutty-product-card__action-btn chutty-product-card__wishlist wishlist-button--card',
          handle: handle,
          id: id,
        })
      );

      var cartLink = document.createElement('a');
      cartLink.className = 'chutty-product-card__action-btn chutty-product-card__cart';
      cartLink.href = url;
      cartLink.setAttribute('aria-label', 'Select options');
      cartLink.innerHTML =
        '<span class="chutty-product-card__cart-icon" aria-hidden="true">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="16" height="16">' +
        '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4" d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686"/>' +
        '</svg></span>';
      actions.appendChild(cartLink);
    }

    return li;
  }

  function initWishlistPage(host) {
    if (!(host instanceof HTMLElement) || host.dataset.wishlistPageReady === 'true') return;
    host.dataset.wishlistPageReady = 'true';

    var grid = host.querySelector('[data-wishlist-grid]');
    var empty = host.querySelector('[data-wishlist-empty]');
    var loading = host.querySelector('[data-wishlist-loading]');
    if (!grid || !empty) return;

    function render() {
      var items = getItems();

      if (items.length === 0) {
        grid.replaceChildren();
        grid.hidden = true;
        empty.hidden = false;
        if (loading) loading.hidden = true;
        return;
      }

      empty.hidden = true;
      grid.hidden = false;
      if (loading) loading.hidden = false;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      Promise.all(
        items.map(function (item) {
          return fetch(root + 'products/' + item.handle + '.js', { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) return null;
              return response.json();
            })
            .catch(function () {
              return null;
            })
            .then(function (product) {
              return productFromItem(item, product);
            });
        })
      ).then(function (products) {
        grid.replaceChildren();

        products.forEach(function (product) {
          grid.appendChild(createWishlistCard(product));
        });

        if (loading) loading.hidden = true;
      });
    }

    document.addEventListener(WISHLIST_EVENT, render);
    render();
  }

  function upgradeCustomElements() {
    document.querySelectorAll('wishlist-icon').forEach(initWishlistIcon);
    document.querySelectorAll('wishlist-page').forEach(initWishlistPage);
  }

  var booted = false;

  function boot() {
    if (booted) return;
    booted = true;

    document.addEventListener('click', handleClick, true);
    document.addEventListener('keydown', handleKeydown);
    mountWishlistPageIfNeeded();
    syncAllButtons();
    upgradeCustomElements();

    document.dispatchEvent(
      new CustomEvent(WISHLIST_EVENT, {
        detail: { items: getItems(), count: getCount() },
      })
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', function () {
    mountWishlistPageIfNeeded();
    syncAllButtons();
    upgradeCustomElements();
  });

  var observer = new MutationObserver(function (mutations) {
    var shouldSync = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return (
          node instanceof HTMLElement &&
          (node.matches(TOGGLE_SELECTOR) ||
            node.matches('wishlist-icon') ||
            node.matches('wishlist-page') ||
            node.querySelector(TOGGLE_SELECTOR) ||
            node.querySelector('wishlist-icon') ||
            node.querySelector('wishlist-page'))
        );
      });
    });

    if (!shouldSync) return;

    syncAllButtons();
    upgradeCustomElements();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.ChuttyWishlist = {
    getItems: getItems,
    getCount: getCount,
    has: has,
    toggle: toggle,
    syncAllButtons: syncAllButtons,
  };
})();
